/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-22T13:39:18+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-21T15:59:19+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import transitions from './../../../transitions/transitions';
import ScaleIn from './../../../transitions/ScaleIn';
import {LANDSCAPE, PORTRAIT} from './../constants/mode';

/**
 * TODO jsdoc
 *
 * @param {object} props
 * @param {object} state
 * @return {object}
 */
function getStyles(props, state) {
  const {selectedYear} = state;
  const styles = {
    monthDay: {
      opacity: selectedYear ? 0.5 : 1,
      transition: transitions.easeOut(),
    },
    // monthDayTitle: {
    //     cursor: !selectedYear ? 'default' : 'pointer',
    // },
    year: {
      opacity: selectedYear ? 1 : 0.5,
      transition: transitions.easeOut(),
    },
    // yearTitle: {
    //     cursor: props.disableYearSelection ? 'not-allowed' : (!selectedYear ? 'pointer' : 'default'),
    // },
  };

  return styles;
}

/**
 * MDisplayDate - …
 */
class MDisplayDate extends Component {
    state = {
      selectedYear: false,
      transitionDirection: 'up',
    };

    /**
     * react lifecycle componentWillMount() <MDisplayDate>
     *
     * @return {undefined}
     */
    componentWillMount() {
      if (!this.props.monthDaySelected) {
        this.setState({selectedYear: true});
      }
    }

    /**
     * react lifecycle componentWillReceiveProps() <MDisplayDate>
     *
     * @param {object} nextProps
     * @return {undefined}
     */
    componentWillReceiveProps(nextProps) {
      if (nextProps.selectedDate !== this.props.selectedDate) {
        const direction = nextProps.selectedDate > this.props.selectedDate ? 'up' : 'down';
        this.setState({
          transitionDirection: direction,
        });
      }

      if (nextProps.monthDaySelected !== undefined) {
        this.setState({
          selectedYear: !nextProps.monthDaySelected,
        });
      }
    }

    /**
     * react render() <MActionsCalendar>
     *
     * @return {object}
     */
    render() {
      const {
        disableYearSelection, // eslint-disable-line no-unused-vars
        mode, // eslint-disable-line no-unused-vars
        monthDaySelected, // eslint-disable-line no-unused-vars
        onPressMonthDay, // eslint-disable-line no-unused-vars
        onPressYear, // eslint-disable-line no-unused-vars
        selectedDate, // eslint-disable-line no-unused-vars
        style,
        ...other
      } = this.props;

      const styles = getStyles(this.props, this.state);
      const year = selectedDate.getFullYear();

      const dateTimeFormatted = `${moment(selectedDate).format(mode === PORTRAIT ? 'dddd, Do MMM' : 'dd, Do MMM')}`;

      return (
        <div
          {...other}
          className={`m-display m-display-date ${mode}`}
          style={style}
          onClick={this.handleOnPress}
        >
          <ScaleIn
            className="m-display-date__year"
            style={styles.year}
          >
            <div
              className="m-display-date__year-title"
              key={year}
              // style={styles.yearTitle}
              // onClick={this.handleOnPressYear}
            >
              {year}
            </div>
          </ScaleIn>
          <ScaleIn
            className="m-display-date__month-day"
            style={styles.monthDay}
          >
            <div
              className="m-display-date__month-day-title"
              key={dateTimeFormatted}
              // onClick={this.handleOnPressMonthDay}
              // style={styles.monthDayTitle}
            >
              {dateTimeFormatted}
            </div>
          </ScaleIn>
        </div>
      );
    }

    handleOnPress = () => {
      if (this.state.selectedYear) {
        this.onToggleToMonthDay();
      } else {
        this.onToggleToYear();
      }
    }

    /**
     * callback for set up of monthDay-view
     *
     * @return {undefined}
     */
    onToggleToMonthDay() {
      if (this.props.onPressMonthDay && this.state.selectedYear) {
        this.props.onPressMonthDay();
      }

      this.setState({selectedYear: false});
    }

    /**
     * callback for set up of year-view
     *
     * @return {undefined}
     */
    onToggleToYear() {
      if (this.props.onPressYear && !this.props.disableYearSelection && !this.state.selectedYear) {
        this.props.onPressYear();
      }

      if (!this.props.disableYearSelection) {
        this.setState({selectedYear: true});
      }
    }
}
MDisplayDate.propTypes = {
  selectedDate: PropTypes.object.isRequired,
  disableYearSelection: PropTypes.bool,
  mode: PropTypes.oneOf([LANDSCAPE, PORTRAIT]),
  monthDaySelected: PropTypes.bool,
  onPressMonthDay: PropTypes.func,
  onPressYear: PropTypes.func,
  style: PropTypes.object,
};
MDisplayDate.defaultProps = {
  disableYearSelection: false,
  monthDaySelected: true,
  mode: PORTRAIT,
};
export default MDisplayDate;

